import { InputLabel as MaterialInputLabel } from '@mui/material'

const InputLabel = MaterialInputLabel

export { InputLabel }
